export let defaultMetal = 'arsenic';

export let metalsList = ['arsenic', 'lead', 'mercury'];
